module.exports = __webpack_public_path__ + "static/CalibreWeb-Semibold-6c5da745111ee3a2e72124c7ae0a0f7e.woff";